/**
 * Domains that are always allowed, whatever the domain_allowlist holds.
 *
 * A copy of FALLBACK_ALLOWED_SIGN_IN_DOMAINS in
 * functions/python/app/infrastructure/config/sign_in.py, which is what the
 * sign-in gate, the CSV import and registration actually use. The backend test
 * test_built_in_domains_contract.py fails when the two lists differ. Changing
 * the list is a reviewed deploy, so the Domains tab shows these as entries
 * that cannot be removed.
 */
export const BUILT_IN_DOMAINS: readonly string[] = [
  "holtzbrinck.com",
  "chaptr.com",
];
